const DOMContentLoaded = () => {
  document.querySelector('#header-row').scrollIntoView({ behavior: 'smooth' })

  const isMobile =
    'ontouchstart' in document.documentElement ||
    /iphone|ipod|ipad|android|iemobile|blackberry|bada|playbook|silk/i.test(
      navigator.userAgent
    )

  function setSmoothScrolling(device) {
    const navLinks = document.querySelectorAll('.nav-link')
    navLinks.forEach(navLink => {
      navLink.addEventListener('click', e => {
        e.preventDefault()
        const section = document.querySelector(navLink.hash)
        const content = document.querySelector('#content')
        if (device === 'mobile') {
          content.scroll(0, section.offsetTop - 80)
        } else if (device === 'desktop') {
          section?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
        if (window.matchMedia('(max-width: 1023px)').matches) {
          document.querySelector('#sidebar').classList.toggle('active')
        }
      })
    })
  }

  function adjustForMobile() {
    const userAgent = navigator.userAgent
    if (!userAgent.match(/chrome|chromium|crios/i)) {
      document.querySelector('body').style.overflow = 'hidden'
    }
    document.querySelector('body').style.position = 'relative'
    document.querySelector(
      '#main-container'
    ).style.maxHeight = `${window.screen.availHeight}px`
    document.querySelector('#sidebar').style.overflowY = 'auto'
    document.querySelector(
      '#sidebar-components'
    ).style.maxHeight = `${window.screen.availHeight}px`
    document.querySelector('#header-row').style.top = '0'
    document.querySelector('#header-row').style.paddingTop = '0'
    document.querySelector('#header-row').classList.add('container-fluid')

    const headerHeight = document.querySelector('#header-row').offsetHeight
    document.querySelector('#search-offcanvas').style.width = '100vw'
    if (window.matchMedia('(max-width: 1023px)').matches) {
      document.querySelector('#content').style.width = '100vw'
    }
    document.querySelector('#content').style.height = `${
      window.screen.availHeight - headerHeight
    }px`
    document.querySelector('#content').style.scrollBehavior = 'smooth'
    document.querySelector('#content').classList.add('pb-5')

    window.addEventListener('resize', () => {
      document.querySelector('#content').style.height = `${
        window.screen.availHeight - headerHeight
      }px`
    })

    setSmoothScrolling('mobile')
  }

  function adjustForDesktop() {
    const height = document.querySelector('#header-row').offsetHeight
    document.querySelector('#content').style.height = `${
      window.innerHeight - (height + 1)
    }px`

    window.addEventListener('resize', () => {
      document.querySelector('#content').style.height = `${
        window.innerHeight - (height + 1)
      }px`
    })

    setSmoothScrolling('desktop')
  }

  function generalAdjust() {
    const toggleSidebar = () => {
      document.querySelector('#sidebar').classList.toggle('active')
    }

    const handleDropdownToggle = event => {
      const clickedItem = event.target.closest('li')

      if (!clickedItem) {
        return
      }

      const isActive = clickedItem.classList.contains('active')

      document.querySelectorAll('li').forEach(item => {
        item.classList.remove('active')
      })

      if (!isActive) {
        clickedItem.classList.add('active')
      }
    }

    const handleSearchClick = () => {
      const offCanvas = document.querySelector('#search-offcanvas')
      offCanvas.classList.toggle('show')
    }

    document
      .querySelector('#sidebarCollapse')
      .addEventListener('click', toggleSidebar)
    document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
      toggle.addEventListener('click', handleDropdownToggle)
    })
    document.querySelectorAll('.sidebar-item').forEach(item => {
      item.addEventListener('click', handleDropdownToggle)
    })
    document
      .querySelector('#sidebar-search-btn')
      .addEventListener('click', handleSearchClick)

    document.querySelector('#content').addEventListener('click', () => {
      const sidebar = document.querySelector('#sidebar')
      if (
        sidebar.classList.contains('active') &&
        !window.matchMedia('(max-width: 769px)').matches
      ) {
        sidebar.classList.remove('active')
      }
    })

    document.querySelector('#scroll-top-btn').addEventListener('click', () => {
      document
        .querySelector('#content')
        .scrollTo({ top: 0, behavior: 'smooth' })
    })
  }

  if (isMobile) {
    adjustForMobile()
  } else {
    adjustForDesktop()
  }
  generalAdjust()
}

export default DOMContentLoaded
